import { useParams, Link } from 'react-router-dom'
import CaseDetail from '../components/admin/CaseDetail'
import ar from '../locales/ar.json'

export default function CaseDetailPage() {
  const { id } = useParams()
  return (
    <div>
      <div className="mb-4">
        <Link to="/admin" className="text-xs text-primary-600 hover:text-primary-800">
          ← {ar.admin.backToCases}
        </Link>
      </div>
      <CaseDetail caseId={id} />
    </div>
  )
}
